import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PreviousPageService } from 'src/app/core/services/previous-page.service';

@Injectable({
  providedIn: 'root',
})
export class AssetCardRedirectService {
  constructor(
    private router: Router,
    private previousPageService: PreviousPageService,
  ) {}

  openOverviewFromAsset(): void {
    this.previousPageService.setPreviousFleetUrl(this.router.url);

    this.router.navigate(['/site/overview']);
  }

  openSiteWithRedFlags(workspaceId: string): void {
    this.previousPageService.setPreviousSiteUrl(this.router.url);

    this.router.navigate([`/site/${workspaceId}`]);
  }
}
